import React, { Component } from 'react';
import CoursesOfferedSection from './components/CoursesOfferedSection';
import SectionContactUsForm from './components/SectionContactUsForm';
import Footer from './components/Footer';
import {coursesOffered } from './data';
import Navbar from './components/Navbar';
import R from 'ramda';

import ReactGA from 'react-ga';

export function toggleCourseDescription(courseTitle) {
  return function update(state) {
    const currentState = R.clone(state.coursesOffered);
    const currentCourseObj = R.find(R.propEq('title', courseTitle), currentState);
    const currentCourseObjIndex = R.find(R.propEq('title', courseTitle), currentState);
    currentCourseObj.showDescription = !currentCourseObj.showDescription;
    const updatedState = currentState;
    updatedState[currentCourseObjIndex] = currentCourseObj;
    return {coursesOffered: updatedState};
  }
}

class CoursesOfferedPage extends Component {

  constructor() {
    super();
    this.state = {
      coursesOffered: R.map(R.assoc('showDescription', false), R.prop('courses', coursesOffered))
    }
    ReactGA.initialize('UA-93233224-1');
    ReactGA.pageview(window.location.pathname);
  }

  handleToggleCourseDescription(e) {
    e.preventDefault();
    this.setState(toggleCourseDescription(e.target.innerText));
  }

  render() {
    ReactGA.pageview(window.location.pathname);
    const currentCourseUrl = R.path(['params', 'courseName'], this.props);
    const {contactUs} = coursesOffered;
    const isCurrentCourse = (xs) => R.prop('url', xs) === currentCourseUrl;
    const currentCourseDescriptions = R.filter(isCurrentCourse, R.prop('coursesOffered', this.state));
    const courseSectionHeaderInfo = { title: currentCourseDescriptions[0].category, bodyText: "" }
    return (
      <div className='courses-offered-page sticky-nav-always' id='home'>
        <Navbar />
        <CoursesOfferedSection sectionHeader={courseSectionHeaderInfo} courses={currentCourseDescriptions} toggleCourseDescription={(e) => this.handleToggleCourseDescription(e)}/>
        <SectionContactUsForm contactUsData={contactUs}/>
        <Footer />
      </div>
    )
  }
}

CoursesOfferedPage.propTypes = {
  params: React.PropTypes.object.isRequired
}

export default CoursesOfferedPage;



// WEBPACK FOOTER //
// ./src/CoursesOfferedPage.js